import { useId, useRef, useState, type InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type PasswordFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label?: string;
};

export function PasswordField({ label = 'Password', id, disabled, ...props }: PasswordFieldProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const inputRef = useRef<HTMLInputElement>(null);
  const [visible, setVisible] = useState(false);

  return <div className="pb-field">
    <label htmlFor={inputId}>{label}</label>
    <div className="pb-password-input">
      <input
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        {...props}
        id={inputId}
        ref={inputRef}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
      />
      <button
        className="pb-icon-button pb-password-toggle"
        type="button"
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-controls={inputId}
        disabled={disabled}
        onPointerDown={event => {
          if (document.activeElement === inputRef.current) event.preventDefault();
        }}
        onClick={() => setVisible(current => !current)}
      >
        {visible ? <EyeOff size={20} aria-hidden="true"/> : <Eye size={20} aria-hidden="true"/>}
      </button>
    </div>
  </div>;
}
